import { render, staticRenderFns } from "./EmailBasedFlowEditor.vue?vue&type=template&id=4e0d3c7e&"
import script from "./EmailBasedFlowEditor.vue?vue&type=script&lang=ts&"
export * from "./EmailBasedFlowEditor.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports